import _extends from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import React from "react";
var __jsx = React.createElement;
import { Radio } from "@mantine/core";
/** SDS radio built on Mantine; checked/hover/disabled styling comes from the app-wide theme. */
export function FormRadio(props) {
  return /*#__PURE__*/React.createElement(Radio, _extends({
    size: "sm"
  }, props));
}